const termsData = [
  {
    title: "Account Security",
    description: null,
    points: [
      "You are responsible for keeping your username and password secure.",
      "You are responsible for all activities carried out using your account, whether you log in directly or through an approved third-party authentication service. ",
      "Do not share your login credentials with anyone.",
      "If you suspect unauthorized access to your account or any security breach, please notify the Edsider support team immediately. "
    ]
  },


  {
    title: "Use of the Platform",
    description: "By using Edsider, you agree to:",
    points: [
      "Use the platform only for your own examinations and academic activities.",
      "Provide accurate information when creating or accessing your account.",
      "Follow all examination instructions and institutional regulations.",
      "Use the platform responsibly and avoid activities that interfere with normal operation."
    ]
  },

  {
    title: "Content Rights",
    description: "You retain ownership of any examination answers, assignments, or other materials you submit through Edsider.By submitting content through the platform, you confirm that:",
    points: [
      "The work is your own or you have the necessary permission to submit it.",
      "The content does not infringe upon the copyright, intellectual property, privacy, or other legal rights of any individual or organization.",
      "You grant Edsider permission to securely store, process, and use your submissions for examination administration, assessment, academic records and related educational purposes."
    ]
  },

  {
    title: "Academic Integrity",
    description: "Students are expected to complete all examinations honestly.Edsider reserves the right to suspend or terminate access to the platform without prior notice if a user:",
    points: [
      "Violates these Terms & Conditions",
      "Engages in academic misconduct",
      "Misuses the platform",
      "Performs any activity that compromises the security, integrity or availability of the platform."
    ]
  },



  {
    title: "Technical requirements ",
    description: null,
    points: [
      "Make sure you have a stable internet connection and a compatible device before starting your examination.",
      "It is your responsibility to check that your equipment is functioning properly.  ",
      "If you experience technical issues during an examination, contact the examination support team as soon as possible."
    ]
  },


  {
    title: "Data protection & privacy",
    description: null,
    points: [
      "Your personal information will be handled in accordance with our Privacy Policy.",
      "Information collected through this platform is used only for examination of administration, security, and related academic purposes.",
      "By using Edsider, you consent to the collection and use of your information in accordance with our Privacy Policy"
    ]
  },


  {
    title: "Platform availability",
    description: "We work to provide reliable examination services. However, temporary interruptions or maintenance may occasionally occur. Where possible, we will notify users of planned maintenance in advance. ",
    points: []
  },


  {
    title: "Data Backup",
    description: "Edsider performs regular system backups to help protect user data. However, while we make every reasonable effort to safeguard your information, we cannot guarantee that data loss or corruption will never occur. ",
    points: []
  },


  {
    title: "Technical support",
    description: "Our team will make reasonable efforts to investigate and resolve any known technical issues affecting the platform. However, Edsider cannot guarantee the successful recovery or restoration of any lost or corrupted data and accepts no liability for circumstances beyond our reasonable control.",
    points: []
  },


  {
    title: "Changes to these terms",
    description: "These Terms & Conditions may be updated from time to time. Continued use of the platform indicates your acceptance of any revised terms.",
    points: []
  },

];


export default termsData;